<nav class="container navbar navbar-expand-lg">
  <a class="navbar-brand" routerLink="/">
    <img src="/assets/brandripplr-logo.svg">
  </a>
  <button class="navbar-toggler" type="button" (click)="toggleNav()">
    <img src="/assets/images/menu.svg">
  </button>
  <div class="navbar-collapse" [ngClass]="{'hide_mobile': !showNav}">
    <button class="navbar-toggler" type="button" (click)="toggleNav()">
      <img src="/assets/images/close.svg">
    </button>
    <ul class="navbar-nav  ms-auto">
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="activePageLink" routerLink="/" [routerLinkActiveOptions]="{exact: true}">Home</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="activePageLink" routerLink="/influencer-marketing-platform">Features</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="activePageLink" routerLink="/influencer-marketing-services">Services</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="activePageLink" routerLink="/brands-and-agencies">Brands</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="activePageLink" routerLink="/influencer-platform-for-creators">Influencers</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" routerLinkActive="activePageLink" routerLink="/creator-awards">Awards</a>
      </li>
      <li class="nav-item">
        <a class="demo-link text-decoration-none"  routerLink="/contact-us">Book a demo</a>
      </li>
      <li class="nav-item">
        <app-signup-popup-button className="sign-up-link">Sign In</app-signup-popup-button>
      </li>
    </ul>
  </div>
</nav>
